import { render, staticRenderFns } from "./LB.vue?vue&type=template&id=6f929bb8"
import script from "./LB.vue?vue&type=script&lang=js"
export * from "./LB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports